import { useMemo, useState } from "react";
import { hierarchy, pack } from "d3-hierarchy";

export default function BubblePack({ items, onClick, height = 520, valueLabel = (d) => d.sub }) {
  const [tip, setTip] = useState(null);
  const W = 900, H = height;

  const nodes = useMemo(() => {
    if (!items?.length) return [];
    const root = hierarchy({ children: items }).sum((d) => Math.max(d.value || 0, 0.0001));
    pack().size([W, H]).padding(4)(root);
    return root.leaves();
  }, [items, H]);

  if (!nodes.length) return null;

  return (
    <div className="relative" data-testid="bubble-pack">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto select-none">
        {nodes.map((n, i) => (
          <g key={i} transform={`translate(${n.x},${n.y})`}
            className="cursor-pointer"
            onClick={() => onClick?.(n.data)}
            onMouseEnter={() => setTip({ x: n.x, y: n.y, d: n.data })}
            onMouseLeave={() => setTip(null)}
            data-testid={`bubble-${i}`}>
            <circle r={n.r} fill={n.data.color || "#059669"} fillOpacity={0.16} stroke={n.data.color || "#059669"} strokeOpacity={0.65} strokeWidth={1.2} />
            {n.r > 26 && (
              <>
                <text textAnchor="middle" dy="-2" fill="#F3F4F6" fontSize={Math.min(15, n.r / 2.6)} fontFamily="JetBrains Mono, monospace" fontWeight="600">{n.data.label}</text>
                <text textAnchor="middle" dy={Math.min(15, n.r / 2.6) + 2} fill="#9CA3AF" fontSize={Math.min(11, n.r / 3.4)} fontFamily="JetBrains Mono, monospace">{valueLabel(n.data)}</text>
              </>
            )}
          </g>
        ))}
      </svg>
      {tip && (
        <div className="absolute pointer-events-none bg-[#121212] border border-[#262626] rounded-sm px-2.5 py-1.5 text-xs z-10"
          style={{ left: `${(tip.x / W) * 100}%`, top: `${(tip.y / H) * 100}%`, transform: "translate(-50%, -130%)" }}>
          <div className="font-medium text-[#F3F4F6]">{tip.d.tooltip || tip.d.label}</div>
          <div className="num text-[#9CA3AF]">{tip.d.sub}</div>
        </div>
      )}
    </div>
  );
}
